"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInSection = void 0;
const FormQuestionType_1 = __importDefault(require("../FormQuestionType"));
function isInSection(form, section, question, depth = 0) {
    if (!question)
        return false;
    if (depth > 0 && (question === null || question === void 0 ? void 0 : question.type) === FormQuestionType_1.default.SECTION)
        return false;
    if (depth > 0 && (question === null || question === void 0 ? void 0 : question.type) === FormQuestionType_1.default.REPETITION)
        return false;
    if ((question === null || question === void 0 ? void 0 : question.nodeId) === section.nodeId)
        return true;
    if ((question === null || question === void 0 ? void 0 : question.parentNodeId) === section.nodeId)
        return true;
    if ((question === null || question === void 0 ? void 0 : question.parentNodeId) === 'root')
        return false;
    return isInSection(form, section, form.questions[question === null || question === void 0 ? void 0 : question.parentNodeId], depth + 1);
}
exports.isInSection = isInSection;
exports.default = isInSection;
